import EnumWalletTypes from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";

import { OperationSmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";

export enum AddressBookFilterType {
  HotWallet = "hotWallet",
  EOAHotWallet = "eoaHotWallet",
  ContractHotWallet = "contractHotWallet",
  InvokerWallet = "invokerWallet",
  SweepDestWallet = "sweepDestWallet",
}

export const createAddressBookFilterConfig = (
  type: AddressBookFilterType,
  config: {
    t: (key: string) => string;
  },
) => {
  const { t } = config;

  const HOT_WALLET_CONFIG = {
    id: AddressBookFilterType.HotWallet,
    label: t(`enumConstants.hotWallet`),
    wallet_types: [String(EnumWalletTypes.HotWallet)],
  };

  const SWEEP_DEST_WALLET_CONFIG = {
    id: AddressBookFilterType.SweepDestWallet,
    label: t(`enumConstants.sweepDestWallet`),
    wallet_types: [String(EnumWalletTypes.SweepDestWallet)],
  };

  const INVOKER_WALLET_CONFIG = {
    id: AddressBookFilterType.InvokerWallet,
    label: t(`enumConstants.InvokerWallet`),
    wallet_types: [String(EnumWalletTypes.InvokerWallet)],
  };

  const EOA_HOT_WALLET_CONFIG = {
    id: AddressBookFilterType.EOAHotWallet,
    label: t(`enumConstants.eoaHotWallet`),
    wallet_types: [String(EnumWalletTypes.HotWallet)],
    smart_account_types: [
      OperationSmartAccountType.EOA,
      OperationSmartAccountType.Kernel,
      OperationSmartAccountType.TronRentalEnergyBandwidth,
    ].map(String),
  };

  const CONTRACT_HOT_WALLET_CONFIG = {
    id: AddressBookFilterType.ContractHotWallet,
    label: t(`enumConstants.contractHotWallet`),
    wallet_types: [String(EnumWalletTypes.HotWallet)],
    smart_account_types: [
      OperationSmartAccountType.MultisignWallet,
      OperationSmartAccountType.MultisignWalletKernel,
      OperationSmartAccountType.MultisignWalletTronRentalEnergyBandwidth,
    ].map(String),
  };

  const mapping = {
    [AddressBookFilterType.HotWallet]: HOT_WALLET_CONFIG,
    [AddressBookFilterType.EOAHotWallet]: EOA_HOT_WALLET_CONFIG,
    [AddressBookFilterType.ContractHotWallet]: CONTRACT_HOT_WALLET_CONFIG,
    [AddressBookFilterType.InvokerWallet]: INVOKER_WALLET_CONFIG,
    [AddressBookFilterType.SweepDestWallet]: SWEEP_DEST_WALLET_CONFIG,
  };

  return mapping[type];
};
